import React from 'react';
import type { IconProps } from '../types';

export const LayerBackground = (props: IconProps) => (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.0801 8.92383C22.013 8.92383 23.5799 10.4909 23.5801 12.4238V19.0801C23.5801 21.0131 22.0131 22.5801 20.0801 22.5801H13.4238C11.4908 22.5801 9.92383 21.0131 9.92383 19.0801V16.6562H14.6562C16.3131 16.6562 17.6562 15.3131 17.6562 13.6562V8.92383H20.0801Z"
      fill="currentColor"
    />
    <rect
      x="5.5"
      y="4.5"
      width="11.6565"
      height="11.6565"
      rx="2.5"
      stroke="currentColor"
    />
  </svg>
);

export default LayerBackground;
